import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SolicitudCredito } from 'src/app/models/solicitud-credito.model';
import { DataService } from 'src/app/services/data.service';
import { SolicitudDetalleComponent } from '../solicitud-detalle/solicitud-detalle.component';

@Component({
  selector: 'app-historial',
  templateUrl: './historial.component.html',
  styleUrls: ['./historial.component.css']
})
export class HistorialComponent implements OnInit {

  constructor(private dataService: DataService, private router: Router,  private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getSolicitudes();
  }

  solicitudes: SolicitudCredito[] = []; // Aquí debes llenar la lista con datos reales

  getSolicitudes(){
    var url = "solicitud-credito"
    this.dataService.getData(url).subscribe({
      next: (v) => {
        this.solicitudes = v;
      },
      error: (e) => {
        console.log(e)
      }
    });
  }

  agregarDias(fecha: Date | string, dias: number): Date {
    const nuevaFecha = new Date(fecha);
    nuevaFecha.setDate(nuevaFecha.getDate() + dias);
    return nuevaFecha;
  }


    // Función para ver el detalle de la solicitud
    verDetalle(solicitud: any) {
      const dialogRef = this.dialog.open(SolicitudDetalleComponent, {
        width: '900px',
        height: '600px',
        data: solicitud
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log('El modal se cerró');
      });
    }
  
    // Función para cancelar la solicitud
    cancelarSolicitud(solicitud: any) {
      var url = "solicitud-credito/" + solicitud.guid
      solicitud.estadoSolicitudCredito = 'Cancelada';
      this.dataService.updateData(solicitud, url).subscribe({
        next: (v) => {
          console.log(v)
        },
        error: (e) => {
          console.log(e);
        }
      })
    }


    editarSolicitud(solicitud: any) {
      this.router.navigate(['/nueva-solicitud-credito/' + solicitud.guid]);
    }

}
